import { createAction } from 'redux-starter-kit';


export const putLocations = createAction('PUT_LOCATIONS');
export const putLocationsForSelect = createAction('PUT_LOCATIONS_FOR_SELECT');
export const putLocation = createAction('PUT_LOCATION');
export const removeLocation = createAction('REMOVE_LOCATION');